import { RouteConfig as ClientRouteConfig } from './clients'
import { RouteConfig as LoginsRouteConfig } from './logins'
import { RouteConfig as ProjectRouteConfig } from './projects'
import { RouteConfig as TeamRouteConfig } from './teams'
import { RouteConfig as UsersRouteConfig } from './users'

export const RouteConfig = [
  ...ClientRouteConfig,
  ...LoginsRouteConfig,
  ...ProjectRouteConfig,
  ...TeamRouteConfig,
  ...UsersRouteConfig
]
